
import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const testimonials = [
  {
    name: "Dra. Fernanda Silva",
    role: "Dentista e Proprietária",
    clinic: "Smile Odontologia",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80",
    quote: "A Dr.Cash revolucionou minha clínica. Com o boleto parcelado, aumentamos o número de procedimentos de alto valor e nossa rentabilidade cresceu mais de 30%."
  },
  {
    name: "Dr. Carlos Mendonça",
    role: "Diretor",
    clinic: "Centro Médico Vida",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80",
    quote: "A antecipação de recebíveis da Dr.Cash me permitiu investir em novos equipamentos sem afetar meu fluxo de caixa. O processo é simples e o dinheiro cai no mesmo dia."
  },
  {
    name: "Dra. Patrícia Almeida",
    role: "Diretora Financeira",
    clinic: "Rede Fisio&Saúde",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80",
    quote: "Gerenciar as finanças de 3 unidades ficou muito mais fácil com a Dr.Cash. A plataforma centralizada nos dá visibilidade completa e agiliza todas as operações financeiras."
  },
  {
    name: "Dr. Roberto Gomes",
    role: "Cirurgião Plástico",
    clinic: "Clínica Renove",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80",
    quote: "Desde que começamos a oferecer o boleto parcelado da Dr.Cash, o número de cirurgias aumentou em 40%. Pacientes que antes adiavam procedimentos agora podem realizá-los com facilidade."
  }
];

const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-white relative">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-6">
            O que nossos parceiros dizem
          </h2>
          <div className="h-1 w-20 bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue rounded-full mx-auto mb-6"></div>
          <p className="text-gray-700 max-w-2xl mx-auto">
            Veja como a Dr.Cash tem ajudado clínicas e profissionais de saúde a melhorar sua saúde financeira.
          </p>
        </div>
        
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-4">
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 h-full flex flex-col">
                  <div className="mb-6">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.2 11.3C14.2 8.1 11.7 5.7 8.6 5.7C5.4 5.7 3 8.1 3 11.3C3 14.5 5.4 16.9 8.6 16.9C9.3 16.9 10 16.8 10.6 16.5C10.4 19.3 9.2 20.9 7 22.2L7.1 22.3C9.8 21.4 14.1 18.4 14.1 11.4L14.2 11.3ZM31.2 11.3C31.2 8.1 28.7 5.7 25.6 5.7C22.4 5.7 20 8.1 20 11.3C20 14.5 22.4 16.9 25.6 16.9C26.3 16.9 27 16.8 27.6 16.5C27.4 19.3 26.2 20.9 24 22.2L24.1 22.3C26.8 21.4 31.1 18.4 31.1 11.4L31.2 11.3Z" fill="url(#paint0_linear_4_65)" />
                      <defs>
                        <linearGradient id="paint0_linear_4_65" x1="3" y1="5.7" x2="31.2" y2="5.7" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00D59D" />
                          <stop offset="1" stopColor="#01B8BE" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <p className="text-gray-700 mb-6 flex-grow">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="w-14 h-14 rounded-full mr-4 object-cover"
                    />
                    <div>
                      <p className="font-bold text-drcash-sapphire-blue">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.role}</p>
                      <p className="text-sm text-drcash-tiffany-blue">{testimonial.clinic}</p>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center mt-8">
            <CarouselPrevious className="static mr-2 !bg-white border-drcash-tiffany-blue text-drcash-tiffany-blue hover:bg-drcash-tiffany-blue hover:text-white" />
            <CarouselNext className="static ml-2 !bg-white border-drcash-tiffany-blue text-drcash-tiffany-blue hover:bg-drcash-tiffany-blue hover:text-white" />
          </div>
        </Carousel>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 opacity-5 w-full h-64 shape-wave"></div>
    </section>
  );
};

export default TestimonialsSection;
